import React from 'react'
import LowerFooter from './LowerFooter'
import UpperFooter from './UpperFooter'

export default function Footer() {
    return (
        <>
        <footer>
            <UpperFooter/>
            <LowerFooter />
        </footer>
        </>
    )
}
